import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0073',
    ecrans: ['00-2'],
    params: [
        '?demcleint',
        '?aftcleint',
        '?eplnomprn',
        '?dercleint',
        "?ofadatdeb",
        "?ofadatfin",
        "?unocleint",
        "?eplnummat",
        "?temcleint",
        "?efface_criteres"
    ]
});
